import { Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';
import NokiaFontRegular from '@nokia-csf-uxr/ccfk-assets/fonts/NokiaPureText-Regular.woff';
import NokiaFontBold from '@nokia-csf-uxr/ccfk-assets/fonts/NokiaPureText-Bold.woff';

/**
 * Generation of the PDF for a single band link
 */

/**
 * Register Nokia fonts
 */
Font.register({
  family: 'NokiaFont',
  fonts: [
    {
      src: NokiaFontRegular,
    },
    {
      src: NokiaFontBold,
      fontWeight: 'bold',
    }
  ],
});

/**
 * Style for resume link information
 */
const LINK_INFORMATION_STYLE = StyleSheet.create({
  table: { 
    display: "table",
    width: "auto",
    maxWidth: "30%"
  }, 
  tableRow: { 
    flexDirection: "row" 
  }, 
  tableCol: { 
    width: "50%",
  }, 
  tableCell: { 
    margin: "auto", 
    marginTop: 2.5,
    marginBottom: 2.5
  },
  columnName: { 
    margin: "auto", 
    marginTop: 2.5,
    marginBottom: 2.5,
    fontFamily: "NokiaFont",
    fontWeight: "bold"
  }
});

/**
 * Generate a table which resumes link information
 * @param {*} props 
 * @returns 
 */
const LinkBudgetTable = (props) => (
  <View style={LINK_INFORMATION_STYLE.table}>
    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.columnName}>Link Budget Details</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.columnName}>User's inputs</Text> 
      </View> 
    </View>

    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Link's name</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.linkName}</Text> 
      </View> 
    </View>

    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Site 1</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.pdObj.site1Name}</Text> 
      </View> 
    </View>
      
    { props.advancedLink ?
    <>
      <View style={LINK_INFORMATION_STYLE.tableRow}> 
        <View style={LINK_INFORMATION_STYLE.tableCol}> 
          <Text style={LINK_INFORMATION_STYLE.tableCell}>Site 1 longitude</Text> 
        </View> 
        <View style={LINK_INFORMATION_STYLE.tableCol}> 
          <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.pdObj.site1LongitudeValue} {props.data.pdObj.site1LongitudeDirection}</Text> 
        </View> 
      </View>
      <View style={LINK_INFORMATION_STYLE.tableRow}> 
        <View style={LINK_INFORMATION_STYLE.tableCol}> 
          <Text style={LINK_INFORMATION_STYLE.tableCell}>Site 1 latitude</Text> 
        </View> 
        <View style={LINK_INFORMATION_STYLE.tableCol}> 
          <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.pdObj.site1LatitudeValue} {props.data.pdObj.site1LatitudeDirection}</Text> 
        </View> 
      </View>
    </>
    : <></> }

    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Site 2</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.pdObj.site2Name}</Text> 
      </View> 
    </View>
  
    { props.advancedLink ?
    <>
      <View style={LINK_INFORMATION_STYLE.tableRow}> 
        <View style={LINK_INFORMATION_STYLE.tableCol}> 
          <Text style={LINK_INFORMATION_STYLE.tableCell}>Site 2 longitude</Text> 
        </View> 
        <View style={LINK_INFORMATION_STYLE.tableCol}> 
          <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.pdObj.site2LongitudeValue} {props.data.pdObj.site2LongitudeDirection}</Text> 
        </View> 
      </View>
      <View style={LINK_INFORMATION_STYLE.tableRow}> 
        <View style={LINK_INFORMATION_STYLE.tableCol}> 
          <Text style={LINK_INFORMATION_STYLE.tableCell}>Site 2 latitude</Text> 
        </View> 
        <View style={LINK_INFORMATION_STYLE.tableCol}> 
          <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.pdObj.site2LatitudeValue} {props.data.pdObj.site2LatitudeDirection}</Text> 
        </View> 
      </View>
    </>
    : <></> }
  
    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Path length</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props?.edited_miles ? (props.data.pdObj.pathLength/1.609).toFixed(2) : props.data.pdObj.pathLength} {props?.edited_miles ? "miles" : props.data.pdObj.distanceUnit}</Text> 
      </View> 
    </View>

    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Standard</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.edObj.equipmentStandard}</Text> 
      </View> 
    </View>
  
    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Propagation methodology</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.coObj.multipathOutageStandard}</Text> 
      </View> 
    </View>

    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Propagation condition</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.coObj.propagationCondition}</Text> 
      </View> 
    </View>

    { props.advancedLink ?
    <>
    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Fade factor</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{ Number.parseFloat( props.data.coObj?.fadeOccurenceFactorAuto).toExponential(10) }</Text> 
      </View> 
    </View>
    </>
    : <></> }

    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Rain outage prediction</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.coObj.rainOutageStandard}</Text> 
      </View> 
    </View>

    {props.data.coObj.rainOutageStandard == "ITU.R P530" ?
    <>
    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Rain rate</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.advancedLink ? props.data.coObj.manualRainRate : props.data.coObj.rainRate} mm/hr</Text> 
      </View> 
    </View>
    </>
    : <></> }

    {props.data.coObj.rainOutageStandard == "ITU.R P530" && props.advancedLink ? 
    <>
    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Rain rate standard</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.coObj.rainOutageMethod}</Text> 
      </View> 
    </View>
    </>
    : <></>}

    {props.data.coObj.rainOutageStandard == "ITU.R P530" ?
    <></>
    :
    <>
    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Crane zone</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.coObj.craneZone}</Text> 
      </View> 
    </View>
    </>
    }

    {props.advancedLink ?
    <>
    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Annual outage methodology</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.coObj.annualOutageMethod}</Text> 
      </View> 
    </View>
    </>
    : <></>}

    {props.advancedLink && props.data.coObj.annualOutageMethod != "itu" ?
    <>
    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Average temperature</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.coObj.avgTempValue} {props.data.coObj.avgTempUnit}</Text> 
      </View> 
    </View>
    </>
    : <></> }

    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Field margin</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.coObj.calculationMargin} dB</Text> 
      </View> 
    </View>

    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Equipment</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.equipmentType}</Text> 
      </View> 
    </View>

    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Frequency</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.edObj.frequencyBand == 6.2 ? 6 : props.data.edObj.frequencyBand} GHz</Text> 
      </View> 
    </View>

    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Channel bandwidth</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}>
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.edObj.channelBandwidth} MHz</Text> 
      </View> 
    </View>

    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Configuration</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.edObj.linkConfiguration.match(/[0-9]\+[0-9]/)[0]}</Text> 
      </View> 
    </View>

    {props.data.edObj.linkConfiguration.includes("1+1") || props.data.edObj.linkConfiguration.includes("2+2") || props.data.edObj.linkConfiguration.includes("4+4") ? 
    <>
      <View style={LINK_INFORMATION_STYLE.tableRow}> 
        <View style={LINK_INFORMATION_STYLE.tableCol}>
          <Text style={LINK_INFORMATION_STYLE.tableCell}>Space diversity</Text> 
        </View> 
        <View style={LINK_INFORMATION_STYLE.tableCol}> 
          <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.edObj.linkConfiguration.includes("SD") ? "ON" : "OFF"}</Text> 
        </View> 
      </View>
    </>
    :
    <></>
    }

    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Polarization</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.edObj.linkConfiguration.includes("AP") ? "Alternate polar" : "Copolar"}</Text> 
      </View> 
    </View>

    {props.data.edObj.linkConfiguration.includes("AP") ?
    <>
    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>XPIC</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.edObj.linkConfiguration.includes("XPIC") ? "ON" : "OFF"}</Text> 
      </View> 
    </View>
    </>
    : <></> }

    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Orientation</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.edObj.linkPolarization == "H" ? "Horizontal" : "Vertical"}</Text> 
      </View> 
    </View>

    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Adaptative modulation</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.edObj.adaptiveModulation ? "ON" : "OFF"}</Text> 
      </View> 
    </View>

  {props.data.edObj.adaptiveModulation ? 
  <>
    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Minimum modulation</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.edObj.minModulation}</Text> 
      </View> 
    </View>

    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Maximum modulation</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.edObj.maxModulation}</Text> 
      </View> 
    </View>
  </>
  : 
  <>
    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Modulation</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.edObj.minModulation}</Text> 
      </View> 
    </View>
  </>
  }

  <View style={LINK_INFORMATION_STYLE.tableRow}> 
    <View style={LINK_INFORMATION_STYLE.tableCol}> 
      <Text style={LINK_INFORMATION_STYLE.tableCell}>TX Power</Text> 
    </View> 
    <View style={LINK_INFORMATION_STYLE.tableCol}> 
      <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.edObj.txPowers[0]} dBm</Text> 
    </View> 
  </View>

  <View style={LINK_INFORMATION_STYLE.tableRow}> 
    <View style={LINK_INFORMATION_STYLE.tableCol}> 
      <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.edObj.linkConfiguration.includes("SD") ? "Site 1 main antenna" : "Site 1 antenna"}</Text> 
    </View> 
    <View style={LINK_INFORMATION_STYLE.tableCol}> 
      <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.adObj.site1AntennaMain}</Text> 
    </View> 
  </View>


  {props.data.edObj.linkConfiguration.includes("SD") ?
  <>
    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Site 1 diversity antenna</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.adObj.site1AntennaDiv}</Text> 
      </View> 
    </View>
  </>
  : <></>}
  
  <View style={LINK_INFORMATION_STYLE.tableRow}> 
    <View style={LINK_INFORMATION_STYLE.tableCol}> 
      <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.edObj.linkConfiguration.includes("SD") ? "Site 2 main antenna" : "Site 2 antenna"}</Text> 
    </View> 
    <View style={LINK_INFORMATION_STYLE.tableCol}> 
      <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.adObj.site2AntennaMain}</Text> 
    </View> 
  </View>
  

  {props.data.edObj.linkConfiguration.includes("SD") ?
  <>
    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Site 2 diversity antenna</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.adObj.site2AntennaDiv}</Text> 
      </View> 
    </View>
  </>
  : <></>}

    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Site 1 additional line loss</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.clObj.site1LineMain} dB</Text> 
      </View> 
    </View>

    <View style={LINK_INFORMATION_STYLE.tableRow}> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>Site 2 additional line loss</Text> 
      </View> 
      <View style={LINK_INFORMATION_STYLE.tableCol}> 
        <Text style={LINK_INFORMATION_STYLE.tableCell}>{props.data.clObj.site2LineMain} dB</Text> 
      </View> 
    </View>
  </View>
)

/**
 * Style for the data grid with technical information for each modulation
 */
const LINK_PERFORMANCE_STYLE = StyleSheet.create({
  table: { 
    display: "table", 
    width: "auto", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderRightWidth: 0, 
    borderBottomWidth: 0 
  }, 
  tableRow: { 
    flexDirection: "row" 
  }, 
  tableCol: { 
    width: "15%", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 ,
  }, 
  tableCell: { 
    margin: "auto", 
    marginTop: 5,
    marginBottom: 5
  },
  columnName: { 
    margin: "auto", 
    marginTop: 5,
    marginBottom: 5,
    fontFamily: "NokiaFont",
    fontWeight: "bold"
  }
});

/**
 * Format the time
 * @param {*} totalOutage time which is returned by Spider API
 * @returns x(1) mins x(2) secs
 */
function calculateOutagePerYear(totalOutage){
  var days = 365.2425; // gregorian year
  var secondsyear = days * 24 * 60 * 60;
  let sum = 0;
  sum = secondsyear * totalOutage / 100;
  var totalSecs =  parseInt(sum.toString());
  let secs = totalSecs % 60;
  let mins = parseInt((totalSecs / 60).toString());
  if(mins >= 525600) { // 525600 minutes = 1 year
    return "OUT of RANGE"
  }
  return mins + 'min ' + secs + 'sec';
}

/**
 * Generate a table which contains calculated information of the link
 * @param {*} props 
 * @returns 
 */
const LinkPerformanceTable = (props) => (
  <View style={LINK_PERFORMANCE_STYLE.table}> 
    <View style={LINK_PERFORMANCE_STYLE.tableRow}> 
      <View style={LINK_PERFORMANCE_STYLE.tableCol}> 
        <Text style={LINK_PERFORMANCE_STYLE.columnName}>Modulation</Text> 
      </View> 
      <View style={LINK_PERFORMANCE_STYLE.tableCol}> 
        <Text style={LINK_PERFORMANCE_STYLE.columnName}>Capacity [Mbps]</Text> 
      </View> 
      <View style={LINK_PERFORMANCE_STYLE.tableCol}> 
        <Text style={LINK_PERFORMANCE_STYLE.columnName}>Total Availability [%]</Text> 
      </View> 
      <View style={LINK_PERFORMANCE_STYLE.tableCol}> 
        <Text style={LINK_PERFORMANCE_STYLE.columnName}>Outage/year</Text> 
      </View> 
      <View style={LINK_PERFORMANCE_STYLE.tableCol}> 
        <Text style={LINK_PERFORMANCE_STYLE.columnName}>Fade Margin [dB]</Text> 
      </View> 
      <View style={LINK_PERFORMANCE_STYLE.tableCol}> 
        <Text style={LINK_PERFORMANCE_STYLE.columnName}>TX Power [dBm]</Text> 
      </View>
      <View style={LINK_PERFORMANCE_STYLE.tableCol}> 
        <Text style={LINK_PERFORMANCE_STYLE.columnName}>RX Level [dBm]</Text> 
      </View>
    </View>

    { props.data.modulations.map((line, i) => {  // Loop on modulations because I can't use a for loop in render (I use only i to get data for a specific modulation)
      return (<View style={LINK_PERFORMANCE_STYLE.tableRow}> 
        <View style={LINK_PERFORMANCE_STYLE.tableCol}> 
          <Text style={LINK_PERFORMANCE_STYLE.tableCell}>{ line }</Text> 
        </View> 
        <View style={LINK_PERFORMANCE_STYLE.tableCol}> 
          <Text style={LINK_PERFORMANCE_STYLE.tableCell}>{ props.data.capacities[i].toFixed(1) }</Text> 
        </View> 
        <View style={LINK_PERFORMANCE_STYLE.tableCol}>
          <Text style={LINK_PERFORMANCE_STYLE.tableCell}>{ props.data.availabilities[i] > 0 && props.data.availabilities[i] < 100 ? props.data.availabilities[i].toFixed(7) : "OUT of RANGE" }</Text> 
        </View>
        <View style={LINK_PERFORMANCE_STYLE.tableCol}> 
          <Text style={LINK_PERFORMANCE_STYLE.tableCell}>{ calculateOutagePerYear(props.data.outages[i]) }</Text> 
        </View>
        <View style={LINK_PERFORMANCE_STYLE.tableCol}> 
          <Text style={LINK_PERFORMANCE_STYLE.tableCell}>{ props.data.fadeMargins[i].toFixed(2) }</Text> 
        </View> 
        <View style={LINK_PERFORMANCE_STYLE.tableCol}> 
          <Text style={LINK_PERFORMANCE_STYLE.tableCell}>{ props.data.txPowers[i] }</Text> 
        </View> 
        <View style={LINK_PERFORMANCE_STYLE.tableCol}> 
          <Text style={LINK_PERFORMANCE_STYLE.tableCell}>{ props.data.rxLevels[i].toFixed(2) }</Text> 
        </View> 
      </View>)  ;
      }) 
    }
  </View>
)

// Create PDF_STRUCTURE_STYLE
const PDF_STRUCTURE_STYLE = StyleSheet.create({
  page: {
    flexDirection: 'column'
  },
  logo: {
    width: 150,
    marginLeft: "3vw"
  },
  section: {
    width: '100%',
    padding: 5
  },
  titlePDF: {
    position: "absolute",
    width: "200px",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -15%)", 
    textAlign: "center",
    fontFamily: "NokiaFont",
    fontWeight: "bold",
    fontSize: "10px"
  },
  date: {
    position: "absolute",
    right: "8%",
    top: "30%",
    textAlign: "right",
    fontFamily: "NokiaFont",
    fontSize: "8px"
  },
  rowSection: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 7,
    marginTop: "5vh"
  }
});

const getDate = () => {
  let date = new Date();
  return date.getDate()+"/"+(date.getMonth()+1)+"/"+date.getFullYear();
}

/**
 * Generate the PDF
 * @param {*} props 
 * @returns 
 */
const SingleBandBudgetPDF = (props) => (
  <Document title={props?.link?.link?.name}>
    <Page size="A4" orientation="landscape" style={PDF_STRUCTURE_STYLE.page}>
      <View style={PDF_STRUCTURE_STYLE.rowSection}>
        <Image source="/assets/logo/nokia_logo.png" style={PDF_STRUCTURE_STYLE.logo}></Image>
        <View style={PDF_STRUCTURE_STYLE.titlePDF}>
          <Text>SINGLE BAND LINK BUDGET</Text>
          <Text>{props?.link?.data?.form.pdObj.site1Name} - {props?.link?.data?.form.pdObj.site2Name}</Text>
        </View>
        <View style={PDF_STRUCTURE_STYLE.date}>
          <Text>{ getDate() }</Text>
        </View>
      </View>
      <View style={PDF_STRUCTURE_STYLE.section}>

        <View style={PDF_STRUCTURE_STYLE.rowSection}>

          <LinkBudgetTable edited_miles={props?.link?.edited_miles} linkName={props?.link?.link.name} data={props?.link?.data?.form} advancedLink={props?.link?.link?.idLinkType == 2} equipmentType={props?.link?.link?.type}/>
          <LinkPerformanceTable data={props?.link?.data} />

        </View>

      </View>
    </Page>
  </Document>
);

export default SingleBandBudgetPDF;